package gr.tech.GRAttestation.infrastructure.api

import gr.tech.GRAttestation.models.api.ApiResponse
import gr.tech.GRAttestation.models.api.PaginatedResult
import gr.tech.GRAttestation.models.tables.BasicTableFilters
import gr.tech.GRAttestation.util.ROUTES
import gr.tech.models.skus.SKU_STATUS
import gr.tech.models.skus.SkuDTO
import gr.tech.GRAttestation.models.skus.SkuPreviewDTO
import kotlinx.serialization.json.Json


// CREATE
suspend fun adminCreateNewSKU(
    skuDTO: SkuDTO,
    onSuccess: (ApiResponse<String>) -> Unit,
    onError: (String) -> Unit,
) {
    try {
        val result: ApiResponse<String> = safeApiCallStringBody(
            url = ROUTES.BACKEND.SKUS.ADMIN_SKUS,
            method = "POST",
            body = Json.encodeToString(skuDTO)
        )

        onSuccess(result)
    } catch (e: Exception) {
        onError("failed to adminCreateNewSKU(): $e")
        return
    }
}

// READ
suspend fun adminFetchAllSKUs(
    pageNumber: Int,
    pageSize: Int,
    skuStatus: SKU_STATUS,
    basicFilters: BasicTableFilters,
    onSuccess: (ApiResponse<PaginatedResult<SkuDTO>>) -> Unit,
    onError: (String) -> Unit,
) {
    val urlWithParameters = ROUTES.BACKEND.SKUS.ADMIN_SKUS +
            "?page=$pageNumber&pageSize=$pageSize" +
            "&dateColumn=${basicFilters.dateColumn}" +
            "&asc=${basicFilters.isAscending}" +
            "&before=${basicFilters.isBefore}" +
            "&date=${basicFilters.dateString}" +
            "&status=${skuStatus.name}"

    try {
        val result: ApiResponse<PaginatedResult<SkuDTO>> = safeApiCallStringBody(
            url = urlWithParameters,
            method = "GET",
        )

        onSuccess(result)
    } catch (e: Exception) {
        onError("failed to adminFetchAllSKUs(): $e")
        return
    }
}

// UPDATE

suspend fun adminUpdateSKU(
    editedSku: SkuDTO,
    onSuccess: (ApiResponse<String>) -> Unit,
    onError: (String) -> Unit,
) {
    try {
        val result: ApiResponse<String> = safeApiCallStringBody(
            url = ROUTES.BACKEND.SKUS.ADMIN_SKUS,
            method = "PUT",
            body = Json.encodeToString(editedSku)
        )

        onSuccess(result)
    } catch (e: Exception) {
        onError("Failed to adminUpdateSKU()")
        return
    }
}


// DELETE
suspend fun adminDeleteSKUByID(
    skuId: Int,
    restore: Boolean = false,
    onSuccess: (ApiResponse<Boolean>) -> Unit,
    onError: (String) -> Unit,
) {
    var url = "${ROUTES.BACKEND.SKUS.ADMIN_SKUS_DELETE}/$skuId"
    if (restore) url += "/restore"

    val method = if (restore) "PUT" else "DELETE"

    try {
        val result: ApiResponse<Boolean> = safeApiCallStringBody(
            url = url,
            method = method,
        )

        onSuccess(result)
    } catch (e: Exception) {
        onError("Failed to adminDeleteSKUByID()")
        return
    }
}

/*
    ======================================================
    For base user, used on the frontend form.
    ======================================================
 */
suspend fun fetchSKUOptions(
    onSuccess: (ApiResponse<List<SkuPreviewDTO>>) -> Unit,
    onError: (String) -> Unit,
) {
    try {
        val result: ApiResponse<List<SkuPreviewDTO>> = safeApiCallStringBody(
            url = ROUTES.BACKEND.SKUS.SKUS,
            method = "GET",
        )

        onSuccess(result)
    } catch (e: Exception) {
        onError("failed to fetchSKUOptions(): $e")
        return
    }
}